import { render, staticRenderFns } from "./NowVsFutureTableCDE.vue?vue&type=template&id=685b35dc&scoped=true&"
import script from "./NowVsFutureTableCDE.vue?vue&type=script&lang=js&"
export * from "./NowVsFutureTableCDE.vue?vue&type=script&lang=js&"
import style0 from "./NowVsFutureTableCDE.vue?vue&type=style&index=0&id=685b35dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b35dc",
  null
  
)

export default component.exports